import React from 'react';
import { StyledComponentProps, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';

interface NoticeProps extends StyledComponentProps {
  children: string;
}

const styles = {
  root: (theme: Theme) => ({
    position: 'relative',
    paddingLeft: theme.spacing(2.5),
    '&::before': {
      content: "''",
      display: 'block',
      borderRadius: 2,
      position: 'absolute',
      left: 0,
      background: theme.palette.primary.main,
      width: 4,
      height: '100%',
      margin: 'auto',
      top: 0,
      bottom: 0,
    },
  }),
};

export function Notice({ children }: NoticeProps) {
  return (
    <Typography sx={styles.root} variant="subtitle1">
      {children}
    </Typography>
  );
}
